import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { faceCommands } from '@shared/constants/CommandValues';
import { createUUID } from '@shared/constants/Keys';
import { CommonResourceKey } from '@shared/models/ResourceKeys';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import { useTranslation } from 'react-i18next';

function ExpressionControlField({ value, onChange, disabled }: IControlFieldProps) {
    const { t } = useTranslation();
    const fieldId = createUUID();
    return (
        <FormControl fullWidth>
            <InputLabel id={fieldId}>{t('common:expression.label')}</InputLabel>
            <Select
                disabled={disabled}
                labelId={fieldId}
                value={value}
                label={t('common:expression.label')}
                onChange={(e) => onChange(e.target.value)}>
                {faceCommands.map((c) => (
                    <MenuItem key={c.value} value={c.value}>
                        {t(c.title as CommonResourceKey)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default ExpressionControlField;
